<template>
  <div class="bg-white">
    <div class="container mx-auto">
      <div class="flex size-full flex-col items-center py-0 xl:container lg:mx-auto lg:flex-row">
        <div class="size-full p-5 lg:w-1/2 lg:pt-0 xl:w-3/5">
          <div
            v-if="$cfg.productContactTitle"
            class="mb-8 text-3xl font-bold lg:text-4xl"
            v-html-safe="$cfg.productContactTitle"
          ></div>
          <div v-if="$cfg.productContactUsps && $cfg.productContactUsps.length" class="w-full">
            <div class="product-contact-usp mb-8 flex flex-col xl:grid xl:grid-cols-2 xl:gap-x-2">
              <template v-for="(usp, index) in $cfg.productContactUsps" :key="index">
                <div class="mb-5 flex items-center">{{ usp.label }}</div>
              </template>
            </div>
          </div>
          <div>
            <VcButton
              v-if="!isServiceEmployee"
              to="/dealers"
              class="vc-button vc-button--size--md vc-button--color--primary vc-button--solid--primary w-40"
              >{{ $t("custom.dealers.title") }}</VcButton
            >
          </div>
        </div>
        <div class="flex w-full pt-5 lg:w-1/2 lg:justify-end xl:w-2/5">
          <VcImage v-if="$cfg.productContactImage" :src="$cfg.productContactImage" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useUser } from "@/shared/account/composables/useUser";

const { isServiceEmployee } = useUser();
</script>

<style scoped>
.product-contact-usp div:before {
  content: "";
  width: 25px;
  height: 28px;
  margin-right: 10px;
  background-repeat: no-repeat;
  background-image: url("/static/images/custom/Bullet.png");
}
</style>
